<template>
  <div class="all">
    <b-table
      id="tabela-contato"
      hover
      thead-class="header-contato"
      :items="contatos"
      :fields="fields"
      :per-page="3"
      :total-rows="rows"
      :current-page="currentPage"
      responsive
    ></b-table>
    <b-pagination
      class="paginacao"
      aria-controls="tabela-contato"
      :per-page="3"
      :total-rows="rows"
      align="right"
      v-model="currentPage"
    />
  </div>
</template>

<script>
export default {
  props: {
    contatos: {
      type: Array,
      required: true
    }
  },
  methods: {
    print(item) {
      console.log(item);
    }
  },
  computed: {
    rows() {
      return this.contatos.length;
    }
  },
  data() {
    return {
      currentPage: 1,
      items: this.contatos,
      fields: [
        {
          key: "nome",
          label: "Nome",
          tdClass: "coluna-nome",
          thClass: "header-nome"
        },
        {
          key: "email",
          label: "Email",
          tdClass: "coluninhas"
        },
        { key: "mensagem", label: "Mensagem", tdClass: "mensagem" }
      ]
    };
  }
};
</script>

<style lang="scss">
.all {
  background-color: #f5f5f5;
  font-family: Montserrat Regular !important;
}

.email {
  /*background-color: lightcoral;*/
  max-width: 285px;
  word-wrap: break-word;
}

#tabela-contato {
  background-color: #fff;
}

.table-responsive {
  border-collapse: separate;
  border-spacing: 0;
  background: #efefef;
  box-shadow: 1px 2px 10px rgba(167, 167, 167, 0.25);
}

/* top-left border-radius */
table tr:first-child th:first-child,
table.tabela tr:first-child td:first-child {
  border-top-left-radius: 5px;
}

/* top-right border-radius */
table tr:first-child th:last-child,
table.tabela tr:first-child td:last-child {
  border-top-right-radius: 5px;
}

/* bottom-left border-radius */
table tr:last-child td:first-child {
  border-bottom-left-radius: 5px;
}

/* bottom-right border-radius */
table tr:last-child td:last-child {
  border-bottom-right-radius: 5px;
}

a {
  color: #6c6c6c;
  text-decoration: underline;
}
a:hover {
  color: #6c6c6c;
}
.coluna-nome,
.coluninhas {
  word-wrap: break-word;
  max-width: 22vw;
  width: 18vw;
  min-width: 300px;
}

.detalhes {
  max-width: 30vw;
  width: 12.6vw;
  min-width: 140px;
}

.detalhes,
.coluninhas,
.projeto {
  font-family: Montserrat Regular !important;
  font-weight: 500;

  color: #3f3f3f;
}
.mensagem {
  max-width: 60vw;
  min-width: 400px;
}

.coluna-empresa {
  font-family: Montserrat Medium !important;
  font-weight: bold;
  font-size: 14px;
}

.header-contato tr th div {
  margin-left: 1vw;
}

.table tbody tr td {
  color: #3f3f3f;
  padding-left: 1.6vw;
  vertical-align: middle;
  line-height: 170.4%;
  font-size: 14px;
  line-height: 17px;
}

.table thead {
  background-color: #1793a6;
  color: #ffffff;
  font-family: Montserrat Regular !important;
  font-weight: 100;
  font-size: 16px;
  line-height: 20px;
}

.table {
  border-radius: 5px;
}

.paginacao {
  font-family: Montserrat Regular !important;
  font-size: 14px;
  line-height: 17px;
}
.paginacao .page-item.active .page-link {
  background-color: #1793a6;
  border-color: #1793a6;
}
.paginacao .page-link {
  color: #1793a6;
  background-color: #f5f5f5;
  border: 2px solid #dee2e6;
}
.paginacao .page-item.disabled .page-link {
  color: #1793a6;
  background-color: #f5f5f5;
}
.pagination.paginacao.b-pagination.justify-content-end li:first-child {
  display: none;
}
.pagination.paginacao.b-pagination.justify-content-end li:last-child {
  display: none;
}
@media only screen and (orientation: portrait) {
  .coluninhas,
  .detalhes,
  .header-nome {
    width: 2000px;
  }
  .table tbody tr td {
    padding-left: 3vw;
  }
}
</style>
